import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

// MARBLEX Quests
const marbleXQuests: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-wishlist-added",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch our new Mascot's debut video",
    caption: "Meet our new mascot",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/marblex/MarbleXMascotTrailer.mp4`,
    videoMimeType: "video/mp4",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-trailer-watched",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-trailer",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Check out MARBLEX's new brand page",
    caption: "See what's new",
    linkUrl: "https://www.marblex.io/en/brand",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-website-visited",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-website",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow MARBLEX on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/MARBLEXofficial",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-twitter-followed",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-twitter",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow our Mascot on X",
    caption: "Stay connected with gObY",
    linkUrl: "https://x.com/LFGOB_gObY",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-twitter-2-followed",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-twitter-2",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join MARBLEX Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/marblexgames",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-discord-joined",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-discord",
  },
  {
    type: "link",
    key: "telegram",
    icon: "ApplicationWeb",
    label: "Join Telegram",
    caption: "Join our Telegram community",
    linkUrl: "https://t.me/MARBLEX_official_ENG",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-telegram-joined",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-telegram",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Read on Medium",
    caption: "Learn more about MARBLEX",
    linkUrl: "https://medium.com/marblex",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-medium-visited",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-medium",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch MARBLEX Rebrand Story",
    caption: "Learn about our new direction",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/marblex/MarbleXRebrandTrailer.mp4`,
    videoMimeType: "video/mp4",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-rebrand-video-watched",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-rebrand-video",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "049e040e-9c82-4ba1-bcd6-b635972530a5-onboarding-completed",
    ruleId: "049e040e-9c82-4ba1-bcd6-b635972530a5-onboarding",
  },
];

// @TODO: these quests are not used yet, as they were cancelled prior to them going live.
// if any of these are to be used in the future, please remove all the instances of mux.com videos
// // Ni no Kuni Quests
// const ninoKuniQuests: Quest[] = [
//   {
//     type: "video",
//     key: "watch",
//     icon: "Play",
//     label: "Watch Ni no Kuni trailer",
//     caption: "Learn about what's coming up",
//     videoMimeType: "application/vnd.apple.mpegurl",
//     videoUrl:
//       "https://stream.mux.com/4nvdZP02MW00Vt1r6imAafpxYQ1DvIkxL1JuGJqviDo1E.m3u8",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "9b09a003-6c7f-4942-9136-c966070311cf-trailer-watched",
//     ruleId: "9b09a003-6c7f-4942-9136-c966070311cf-trailer",
//   },
//   {
//     type: "link",
//     key: "x-v2",
//     icon: "X",
//     label: "Follow Ni no Kuni on X",
//     caption: "Don't miss a tweet",
//     linkUrl: "https://x.com/ninokuni_global",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "9b09a003-6c7f-4942-9136-c966070311cf-twitter-followed",
//     ruleId: "9b09a003-6c7f-4942-9136-c966070311cf-twitter",
//   },
//   {
//     type: "link",
//     key: "discord-v2",
//     icon: "Discord",
//     label: "Join Discord channel",
//     caption: "Join our massively growing community",
//     linkUrl: "https://discord.com/invite/ninokuni-official",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "9b09a003-6c7f-4942-9136-c966070311cf-discord-joined",
//     ruleId: "9b09a003-6c7f-4942-9136-c966070311cf-discord",
//   },
//   {
//     type: "link",
//     key: "website",
//     icon: "ApplicationWeb",
//     label: "Download Ni no Kuni",
//     caption: "Start your adventure",
//     linkUrl: "https://ninokuni.netmarble.com/en",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "9b09a003-6c7f-4942-9136-c966070311cf-website-visited",
//     ruleId: "9b09a003-6c7f-4942-9136-c966070311cf-website",
//   },
// ];

// // META WORLD Quests
// const metaWorldQuests: Quest[] = [
//   {
//     type: "video",
//     key: "watch",
//     icon: "Play",
//     label: "Watch META WORLD trailer",
//     caption: "Learn about what's coming up",
//     videoMimeType: "application/vnd.apple.mpegurl",
//     videoUrl:
//       "https://stream.mux.com/gJioXog02XiTRcmw8NvDpA12VtkB1swJsuq2jyO4e2i00.m3u8",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "f9537f6a-c297-459e-8b81-7062f4ebf161-trailer-watched",
//     ruleId: "f9537f6a-c297-459e-8b81-7062f4ebf161-trailer",
//   },
//   {
//     type: "link",
//     key: "x-v2",
//     icon: "X",
//     label: "Follow Meta World on X",
//     caption: "Don't miss a tweet",
//     linkUrl: "https://x.com/MetaWorld_MC",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "f9537f6a-c297-459e-8b81-7062f4ebf161-twitter-followed",
//     ruleId: "f9537f6a-c297-459e-8b81-7062f4ebf161-twitter",
//   },
//   {
//     type: "link",
//     key: "discord-v2",
//     icon: "Discord",
//     label: "Join Discord channel",
//     caption: "Join our massively growing community",
//     linkUrl:
//       "https://discord.com/invite/meta-world-my-city-ekmesrsthii2-lu-you-da-heng-2-961096039799078953",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "f9537f6a-c297-459e-8b81-7062f4ebf161-discord-joined",
//     ruleId: "f9537f6a-c297-459e-8b81-7062f4ebf161-discord",
//   },
//   {
//     type: "link",
//     key: "website",
//     icon: "ApplicationWeb",
//     label: "Download META WORLD",
//     caption: "Start your adventure",
//     linkUrl: "https://metaworld-mycity.netmarble.com/",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "f9537f6a-c297-459e-8b81-7062f4ebf161-website-visited",
//     ruleId: "f9537f6a-c297-459e-8b81-7062f4ebf161-website",
//   },
// ];

// // A3: STILL ALIVE Quests
// const a3StillAliveQuests: Quest[] = [
//   {
//     type: "video",
//     key: "watch",
//     icon: "Play",
//     label: "Watch A3: STILL ALIVE trailer",
//     caption: "Learn about what's coming up",
//     videoMimeType: "application/vnd.apple.mpegurl",
//     videoUrl:
//       "https://stream.mux.com/dNFeBnFJo1DE01msU23SlLoEQccegM6cL585qQSMMyhQ.m3u8",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-trailer-watched",
//     ruleId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-trailer",
//   },
//   {
//     type: "link",
//     key: "website",
//     icon: "ApplicationWeb",
//     label: "Subscribe to A3 YouTube",
//     caption: "Stay up to date with the latest content",
//     linkUrl: "https://www.youtube.com/@A3STILLALIVE",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-youtube-subscribed",
//     ruleId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-youtube",
//   },
//   {
//     type: "link",
//     key: "website",
//     icon: "ApplicationWeb",
//     label: "Pre-register for A3: STILL ALIVE",
//     caption: "Be the first to play",
//     linkUrl: "https://a3.netmarble.com/en/pre-register",
//     increase: 5,
//     badgeIcon: "ImxRewards",
//     badgeTemplate: "+<increase> <icon> Gems",
//     eventId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-website-visited",
//     ruleId: "98b290bf-b154-4c8e-a12c-a7b9ed21a7df-website",
//   },
// ];

export const marbleXQuestsList: QuestGroup[] = [
  {
    key: "marblex",
    header: {
      image: "",
      title: "MARBLEX Rebrand",
      description: "",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +65 <icon> Gems",
    totalGemsGranted: 65,
    quests: marbleXQuests,
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
  },
];
